<template>
  <el-card
    v-if="config"
    class="card-container connection"
    shadow="never"
  >
    <CardHeader
      slot="header"
      :item="item"
      :config="config"
      :total="total"
      :permission="permission"
      :selected-permission="selectedPermission"
      @create="handleCreate"
      @refresh="handleRefresh"
    />
    <div
      v-if="selectedObject && item && objectTypes.length > 0"
      style="display: flex;"
      class="menu-content"
    >
      <div class="menu">
        <el-menu
          :default-active="objectTypeIndex"
          class="el-menu-vertical-demo"
          @select="handleSelectMenu"
        >
          <img
            v-if="item.extra.file_images.length"
            :src="imageUrl"
            class="image-avatar"
            alt=""
          >
          <el-menu-item
            v-for="(ot, index) in objectTypes"
            :key="ot.extra.key"
            :index="`${index}`"
          >
            <span>{{ ot.extra.name }}</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div
        :key="objectTypeIndex"
        class="content p-xl"
      >
        <CardFilter
          @search="handleSearch"
        />
        <CardList
          :config="selectedObject"
          :data="data"
          :loading="loading"
          :permission="permission"
          :selected-permission="selectedPermission"
          @delete="handleDelete"
          @detail="handleView"
        />
        <el-row
          type="flex"
          align="middle"
          justify="end"
          class="mt-l"
        >
          <el-pagination
            background
            :current-page="page"
            :page-sizes="[10, 20, 50, 100, 500, 1000]"
            :page-size="pageSize"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleChangePageSize"
            @current-change="handleChangePage"
          />
        </el-row>
      </div>
    </div>
    <ConnectionFormPopup
      v-if="formVisible"
      :visible="formVisible"
      :item="item"
      :config="config"
      :object="selectedObject"
      :item-relations="itemRelations"
      @close="formVisible = false"
      @reload="loadData"
    />
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import CardHeader from "./components/connection/CardHeader.vue";
import CardFilter from "./components/connection/CardFilter.vue";
import CardList from "./components/connection/CardList.vue";
import ConnectionFormPopup from "./popups/FormData.vue";

import { notification, convertPayloadData } from "@/utils/common";
import commonServices from "@/services/common";
import organizationServices from "@/services/organization"
import { objectPer } from "@/utils/permission";
import constants from "@/config/constants";
import fileServices from '@/services/file';

export default {
  name: "SharedManage",
  components: {
    CardHeader,
    CardFilter,
    CardList,
    ConnectionFormPopup,
  },
  data() {
    return {
      loading: false,
      page: 1,
      pageSize: constants.PAGE_SIZE,
      total: 2,
      item: null,
      data: [],
      formVisible: false,
      searchText: "",
      objectTypeIndex: "0",
      imageUrl: "",
      organizationId: organizationServices.getCurrentOrg()?.id
    };
  },
  computed: {
    ...mapGetters("config", ["allConfigs"]),
    itemRelations() {
      return this.item?.extra?.relations || [];
    },
    config() {
      return this.allConfigs.find((c) => c.id === this.$route.meta.configId);
    },
    objectTypes() {
      return this.allConfigs.filter((c) =>
        this.config?.extra?.relations?.includes(c.extra.key)
      ).filter((c) => {
        const objectType = constants.OBJECT_TYPES.find((t) => t.value === c.type);
        return objectPer(objectType?.role_action).READ;
      });
    },
    selectedObject() {
      return this.objectTypes[Number(this.objectTypeIndex)];
    },
    permission() {
      const objectType = constants.OBJECT_TYPES.find((t) => t.value === this.config.type);
      return objectPer(objectType?.role_action);
    },
    selectedPermission() {
      const objectType = constants.OBJECT_TYPES.find((t) => t.value === this.selectedObject?.key);
      return objectPer(objectType?.role_action);
    },
    params() {
      const _params = {
        offset: (this.page - 1) * this.pageSize,
        limit: this.page * this.pageSize,
        locale: "vi",
      };
      const relationItemIds = this.itemRelations
        .filter(Boolean)
        .map((r) => r.item_id);
      _params.filters = {
        id: { $in: relationItemIds },
        organization_id: this.organizationId,
      };
      if (this.searchText) {
        _params.filters[`extra.name`] = { $regex: this.searchText }
      }
      return _params;
    },
  },
  watch: {
    config: "loadData",
  },
  beforeMount() {
    this.loadData();
  },
  methods: {
    async loadData() {
      if (!this.config && this.objectTypes.length > 0) {
        return;
      }
      if (this.objectTypes.length > 0) {
        this.loading = true;
        await this.loadItem();
        this.listRelations();
      } else {
        this.$router.push({ name: this.config.extra.key });
      }
    },
    async loadItem() {
      await commonServices
        .show(this.config.type, this.$route.params.id)
        .then((response) => {
          this.item = response;
          if (response.extra && response.extra.file_images.length) {
            this.getImageUrl(response.extra.file_images[0])
          }
        })
        .catch(() => {
          this.$router.push({ name: this.config.extra.key });
        });
    },
    async getImageUrl(file) {
      try {
        const response = await fileServices.show(file.id)
        this.imageUrl = response.url
      } catch (error) {
        this.imageUrl = ''
      }
    },
    listRelations() {
      this.loading = true;
      commonServices
        .list(this.selectedObject.type, this.params)
        .then((response) => {
          this.data = response.items.map((i, index) => ({
            ...i,
            stt: index + 1 + this.pageSize * (this.page - 1),
          }));
          this.total = response.meta.total;
          this.loading = false;
        })
        .catch(() => {
          this.data = [];
          this.loading = false;
        });
    },
    handleCreate() {
      this.formVisible = true;
    },
    handleView(item) {
      this.$router.push({
        name: `${item.type}_view`,
        params: { id: item.id },
      })
    },
    handleDelete(relationItem) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        commonServices
          .update(
            this.config.type,
            convertPayloadData(this.config.extra.key, {
              ...this.item,
              extra: {
                ...this.item.extra,
                relations: this.itemRelations.filter(
                  (i) => i.item_id !== relationItem.id
                ),
              },
            })
          )
          .then(async () => {
            if (this.data.length === 1 && this.page > 1) {
              this.page = this.page - 1;
            }
            notification(
              this,
              "success",
              "delete",
              `${this.config.extra.name}`
            );
            await this.handleUpdateRelationItem(relationItem);
            this.loadData();
          })
          .catch(() => {
            notification(this, "error", "delete", `${this.config.extra.name}`);
          });
      });
    },
    async handleUpdateRelationItem(relationItem) {
      try {
        commonServices.update(
          this.selectedObject.type,
          convertPayloadData(this.selectedObject.extra.key, {
            ...relationItem,
            extra: {
              ...relationItem.extra,
              relations:
                relationItem.extra?.relations?.filter(
                  (r) => r.item_id !== this.item?.id
                ) || [],
            },
          })
        );
      } catch (error) {
        console.log(error);
      }
    },
    handleSearch(payload) {
      this.page = 1;
      this.searchText = payload.searchText;
      this.listRelations();
    },
    handleRefresh() {
      this.page = 1;
      this.searchText = "";
      this.listRelations();
    },
    handleChangePage(page) {
      this.page = page;
      this.listRelations();
    },
    handleChangePageSize(size) {
      this.page = 1;
      this.pageSize = size;
      this.listRelations();
    },
    handleSelectMenu(index) {
      this.objectTypeIndex = String(index);
      this.loadData();
    },
  },
};
</script>

<style lang="scss">
.card-container {
  &.connection {
    .el-card__body {
      padding: 0 !important;
      .el-menu {
        height: 100%;
      }
      .image-avatar {
        width: 100%;
        height: 200px;
        object-fit: cover;
      }
      .menu-content {
        width: 100% !important;
        .menu {
          width: 250px;
          .el-menu-item{
            height: 48px;
            line-height: 48px;
            &.is-active {
              color: #2F80ED;
              background-color: #2f81ed2a;
            }
          }
        }
        .content {
          flex: 1;
        }
      }
    }
  }
}
</style>
